export default __webpack_public_path__ + "static/media/share.9086fec4.svg";